import { AppStorage } from './appStorage.js';

export { getStorage } from './storage.js';
export default new AppStorage('socs');
